import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { Container } from "reactstrap";

import { getBrandLogos } from "../helpers/brandPortal";

import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";

/**
 * Sidebar SA — logo aponta para o dashboard SA; sem bloco demo de usuário (DOC 09 § 4.1).
 */
const SuperAdminSidebar = ({ layoutType }: any) => {
  const logos = getBrandLogos();
  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay?.[0]) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to="/super-admin/dashboard" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logos.sm} alt={logos.alt} height="28" />
            </span>
            <span className="logo-lg">
              <img src={logos.dark} alt={logos.alt} height="28" />
            </span>
          </Link>
          <Link to="/super-admin/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img src={logos.sm} alt={logos.alt} height="28" />
            </span>
            <span className="logo-lg">
              <img src={logos.light} alt={logos.alt} height="28" />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default SuperAdminSidebar;
